import {
  addDoc,
  collection,
  connectFirestoreEmulator,
  getDocs,
  getFirestore,
  query,
  where,
} from 'firebase/firestore';
import app from './firebaseApp';

const HOOPS_COLLECTION = 'nyc-hoops';

const db = getFirestore(app);

if (process.env.NODE_ENV === 'development') {
  connectFirestoreEmulator(db, 'localhost', 8080);
}

export const getAllHoops = () => {
  const path = HOOPS_COLLECTION;

  return getDocs(collection(db, path));
};

/**
 * Retrieves the `submissions` collection for the given hoop ID.
 * @param {string} hoopId - The ID of the hoop in Firebase.
 * @return {Promise} A promise that resolves with the submissions.
 */
export const getSubmissionsByHoopId = async (hoopId) => {
  const path = `${HOOPS_COLLECTION}/${hoopId}/submissions`;

  const q = query(collection(db, path), where('verified', '==', true));

  return getDocs(q);
};

/**
 * Adds a new submission to the `submissions` collection for the given hoop.
 * @param {Object} options - The options object.
 * @param {string} options.hoopId - The ID of the hoop in Firebase.
 * @param {Object} newSubmission - The new submission to be added.
 * @return {Promise} A promise that resolves with the added document.
 */
export const addSubmissionToHoop = async ({ hoopId, newSubmission }) => {
  const path = `${HOOPS_COLLECTION}/${hoopId}/submissions`;

  return addDoc(collection(db, path), newSubmission);
};
